import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import React from "react";
import { environment } from "../../environment/environment";
import { ForceUpdateDialogProps } from "../../models/IForceUpdateDialog";

const ForceUpdateDialog: React.FC<ForceUpdateDialogProps> = ({ isOpen, onClose }) => {
  const handleUrl = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!(window as any).electronAPI) return;
    e.preventDefault();
    const url = e.currentTarget.href;
    (window as any).electronAPI?.openExternalUrl({ link: url });
  };

  return (
    <Dialog
      open={isOpen}
      keepMounted
      onClose={onClose}
      aria-describedby="force-update-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="force-update-dialog-description">
          <b>
            Your huddle client is outdated. Please download the&nbsp;
            <a onClick={handleUrl} href={environment.adminPortalUrl}>
              latest client
            </a>
            .
          </b>

        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForceUpdateDialog;
